var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[(_vm.isLoading)?_c('DgSpinner',{staticClass:"page-spinner"}):_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('PageHeading'),_c('TodoList'),_c('Contacts')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }